import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const filters = () => {
  return {
    query: '',
    from: 2018,
    to: 2020,
    min_price: 0,
    max_price: 20000,
    available: true
  }
}

export default new Vuex.Store({
  state: {
    products: [
      { "id": 1, "asset": "E001", "marca": "sanyo","model": "FW32R19F", "Serial":"MXX1340CY" ,"model_year": 2010, "price": "$16996.19", "available": true },
      { "id": 2, "asset": "E002", "marca": "sony","model": "FW33R20F", "Serial":"MXX1341CY" ,"model_year": 2020, "price": "$8780.93", "available": true },
      { "id": 3, "asset": "A003", "marca": "sanyo","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2011, "price": "$8780.93", "available": false },
      { "id": 4, "asset": "B004", "marca": "sony","model": "FW33R19B", "Serial":"MXX1341CY" ,"model_year": 2010, "price": "$8780.93", "available": true },
      { "id": 5, "asset": "A005", "marca": "sanyo","model": "FW33R19", "Serial":"MXX1341CY" ,"model_year": 2013, "price": "$8780.93", "available": true },
      { "id": 6, "asset": "E006", "marca": "sony","model": "FW03R11Z", "Serial":"MXX1341CY" ,"model_year": 2020, "price": "$8780.93", "available": true },
      { "id": 7, "asset": "E007", "marca": "sanyo","model": "AB33R13C", "Serial":"MXX1341CY" ,"model_year": 2014, "price": "$8780.93", "available": false },
      { "id": 8, "asset": "E008", "marca": "sanyo","model": "AB33R19F", "Serial":"MXX1341CY" ,"model_year": 2015, "price": "$8780.93", "available": true },
      { "id": 9, "asset": "E009", "marca": "hp","model": "HD353T19F", "Serial":"MXX1341CY" ,"model_year": 2015, "price": "$8780.93", "available": true },
      { "id": 10, "asset": "E010", "marca": "hp","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2016, "price": "$8780.93", "available": false },
      { "id": 11, "asset": "E011", "marca": "hp","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2017, "price": "$8780.93", "available": true },
      { "id": 12, "asset": "E012", "marca": "hp","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2017, "price": "$8780.93", "available": true },
      { "id": 13, "asset": "E013", "marca": "sanyo","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2018, "price": "$8780.93", "available": true },
      { "id": 14, "asset": "E014", "marca": "samsung","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2019, "price": "$8780.93", "available": true },
      { "id": 15, "asset": "E015", "marca": "samsung","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2019, "price": "$8780.93", "available": false },
      { "id": 16, "asset": "E016", "marca": "samsung","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2019, "price": "$8643.93", "available": true },
      { "id": 17, "asset": "E017", "marca": "sanyo","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2019, "price": "$4325.93", "available": true },
      { "id": 18, "asset": "E018", "marca": "hp","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2020, "price": "$8763.93", "available": false },
      { "id": 19, "asset": "E019", "marca": "hp","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2020, "price": "$1456.93", "available": true },
      { "id": 20, "asset": "E020", "marca": "sanyo","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2011, "price": "$78840.93", "available": false },
      { "id": 21, "asset": "E021", "marca": "hp","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2013, "price": "$6780.93", "available": true },
      { "id": 22, "asset": "E022", "marca": "sanyo","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2014, "price": "$9780.93", "available": true },
      { "id": 23, "asset": "E023", "marca": "hp","model": "FW33R19F", "Serial":"MXX1341CY" ,"model_year": 2019, "price": "$18780.93", "available": false },
      { "id": 24, "asset": "E024", "marca": "sanyo","model": "FW32R18F", "Serial":"MXX1342CY" ,"model_year": 2019, "price": "$7780.93", "available": true },
      { "id": 25, "asset": "Z034", "marca": "hp","model": "ZX32R40C", "Serial":"MXX192873" ,"model_year": 2018, "price": "$6780.93", "available": true }
  ],
    filter: filters()
  },
  mutations: {
    setFilter (state, data) {
      state.filter[data['filter']] = data.value
    },
    resetFilter (state) {
      state.filter = filters()
    }
  },
  getters:{
    filteredproducts(state){
      let products = state.products
      products = products.filter( product => product.available === state.filter.available)
      if (state.filter.query.length > 1) {
        products = products.filter( product => product.asset.includes(state.filter.query))
      }
      
      if (state.filter.from) {
        products = products.filter(product => product.model_year >= state.filter.from)
      }
      if (state.filter.to) {
        products = products.filter(product => product.model_year <= state.filter.to)
      }
      if (state.filter.min_price) {
        products = products.filter(product => {
          const price = parseFloat(product.price.replace('$', ''))
          return price >= state.filter.min_price
        })
      }
      if (state.filter.max_price) {
        products = products.filter(product => {
          const price = parseFloat(product.price.replace('$', ''))
          return price <= state.filter.max_price
        })
      }
      return products
    }
  },
  actions: {
  },
  modules: {
  }
})
